import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Spin } from "antd";
import { toast } from "react-toastify";
import { campusApi } from "../../services/api";

const CampusFormModal = ({ visible, onCancel, onSuccess, editingCampus }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEditing = !!editingCampus;

  useEffect(() => {
    if (visible && isEditing) {
      // Completar formulario con datos existentes si estamos editando
      form.setFieldsValue({
        campus: editingCampus.campus,
      });
    } else if (visible) {
      // Limpiar formulario si estamos creando
      form.resetFields();
    }
  }, [visible, editingCampus, form, isEditing]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (isEditing) {
        // Actualizar campus existente
        await campusApi.update(editingCampus.id, values);
        toast.success("Campus actualizado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Crear nuevo campus
        await campusApi.create(values);
        toast.success("Campus creado correctamente", {
          position: "top-right",
          autoClose: 4000,
        });
      }

      setLoading(false);
      onSuccess();
    } catch (error) {
      console.error("Error al guardar campus:", error);
      let errorMsg = "Error al guardar los datos";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMsg = error.response.data.message;
      }
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 4000,
      });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={isEditing ? "Editar Campus" : "Nuevo Campus"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="mt-4"
        >
          <Form.Item
            label="Nombre del Campus"
            name="campus"
            rules={[
              {
                required: true,
                message: "Por favor ingrese el nombre del campus",
              },
            ]}
          >
            <Input placeholder="Bucaramanga" />
          </Form.Item>

          <div className="flex justify-end gap-2 mt-6">
            <Button onClick={onCancel}>Cancelar</Button>
            <Button
              type="primary"
              htmlType="submit"
              className="bg-blue-600 hover:bg-blue-700"
            >
              {isEditing ? "Actualizar" : "Crear"}
            </Button>
          </div>
        </Form>
      </Spin>
    </Modal>
  );
};

export default CampusFormModal;